import queryString from 'query-string'

export default function stringifyQueryParamsObjectUtil (queryParams) {
  return queryString.stringify(queryParams)
}
